var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import AddIcon from '@mui/icons-material/Add';
import { Button, ButtonGroup, buttonGroupClasses, Divider, Typography, useMediaQuery } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
// import { LineIcon, MenuButtonNew } from '../../assets/images'; 
import { setIsLeftMenuOpen } from '../../redux/commonSlice';
import { MuiStack } from './stackComponent';
import ToggleIconButtonComponent from './toggleIconButtonComponent';
import { ChevronDownIcon } from '../../assets/customIcons';
var PagingHeader = function (props) {
    var _a;
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var commonState = useSelector(function (state) { return state.common; });
    var dispatch = useDispatch();
    var headerTitle = props.headerTitle, _b = props.addButtonText, addButtonText = _b === void 0 ? 'New' : _b, onButtonClick = props.onButtonClick, activeView = props.activeView, onToggleView = props.onToggleView, data = props.data, addButtonDropdown = props.addButtonDropdown, _c = props.onDropDownClick, onDropDownClick = _c === void 0 ? function (e) { } : _c;
    var onLeftDrawerClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(setIsLeftMenuOpen(!commonState.isMenuOpen));
            return [2 /*return*/];
        });
    }); };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "space-between",
        alignItems: "center",
        p: 2,
        pb: 0
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "paging-header-title",
        variant: "h1",
        fontSize: "20px",
        sx: {
            whiteSpace: 'nowrap'
        }
    }, headerTitle ? headerTitle : "Header")), /*#__PURE__*/ React.createElement(MuiStack, {
        id: "paging-header-content",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            border: '1px solid #DEE4EB',
            height: '44px',
            borderRadius: '8px',
            backgroundColor: '#EFF2F5',
            padding: '4px'
        }
    }, /*#__PURE__*/ React.createElement(ToggleIconButtonComponent, {
        activeView: activeView,
        onToggleView: onToggleView
    })), /*#__PURE__*/ React.createElement(Divider, {
        orientation: "vertical",
        flexItem: true
    }), /*#__PURE__*/ React.createElement(ButtonGroup, {
        variant: "contained",
        size: "medium",
        disableElevation: true,
        sx: (_a = {
                height: 44,
                columnGap: '1px'
            },
            _a["& .".concat(buttonGroupClasses.firstButton)] = {
                borderRight: 'none'
            },
            _a)
    }, /*#__PURE__*/ React.createElement(Button, {
        id: addButtonText + '-button',
        startIcon: /*#__PURE__*/ React.createElement(AddIcon, null),
        onClick: onButtonClick,
        sx: {
            height: 'inherit',
            typography: 'h5'
        }
    }, addButtonText), addButtonDropdown && /*#__PURE__*/ React.createElement(Button, {
        id: addButtonText + '-menu',
        onClick: onDropDownClick,
        sx: {
            height: 'inherit'
        }
    }, /*#__PURE__*/ React.createElement(ChevronDownIcon, null)))));
};
export default PagingHeader;
